<template>
  <v-container>
    <div v-if="1==1">
      <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
        <v-form ref="form">
          <v-row>
            <v-col md="12">
              <h1 class="font-weight-medium">{{$t('datos de la bodega')}}</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                    :label="$t('nombre_comercial')+ '*'"
                    filled
                    :error-messages="errors"
                    v-model="bodega.nombre_comercial"
                    maxlength="250"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <ValidationProvider v-slot="{ errors }" name="direccion" rules="required">
                <v-text-field
                    :label="$t('direccion')+ '*'"
                    filled
                    v-model="bodega.direccion"
                    maxlength="250"
                    :error-messages="errors"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="2">
              <ValidationProvider v-slot="{ errors }" name="municipio" rules="required">
                <v-autocomplete
                    :items="municipios"
                    filled
                    :label="$t('municipio')+ '*'"
                    v-model="bodega.municipio"
                    maxlength="250"
                    :error-messages="errors"
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col sm="12" md="2">
              <ValidationProvider v-slot="{ errors }" name="codigo_postal" rules="required|numeric">
                <v-text-field
                    :label="$t('codigo_postal')+ '*'"
                    filled
                    v-model="bodega.codigo_postal"
                    maxlength="6"
                    :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-col cols="12">
            <h4>{{$t("selecciona_la_opcion_que_te_representa")}}</h4>
          </v-col>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.produccion_organica" :label="$t('produccion_organica')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.produccion_biodinamica"
                          :label="$t('produccion_biodinamica')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox :disabled="userNormal" v-model="bodega.produccion_integral" :label="'Elaborador Integral'"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.enoturismo" :label="$t('enoturismo')"></v-checkbox>
            </v-col>
          </v-row>
          <v-col cols="12">
            <h4>{{$t("Categorias de Cava")}}</h4>
          </v-col>
          <v-row>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.joven" :label="$t('joven')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.reserva" :label="$t('reserva')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.gran_reserva" :label="$t('gran_reserva')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox :disabled="userNormal" v-model="bodega.paraje" :label="$t('paraje')"></v-checkbox>
            </v-col>
          </v-row>

          <v-col cols="12">
            <h4>{{$t("Mercados de exportación")}}
            </h4>
          </v-col>

          <v-row cols="12">
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.usa" :label="$t('usa')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.japan" :label="$t('japan')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.belgum" :label="$t('belgum')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.uk" :label="$t('uk')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.germany" :label="$t('germany')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.france" :label="$t('france')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.holand" :label="$t('holand')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.sweeden" :label="$t('sweeden')"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-checkbox v-model="bodega.mercados_otros" :label="$t('others')"></v-checkbox>
            </v-col>
            <v-col cols="4" v-if="bodega.mercados_otros === true">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                    :label="$t('Otros')+ '*'"
                    filled
                    v-model="bodega.mercados_otros_text"
                    maxlength="250"
                    :error-messages="errors"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-col cols="12">
            <h4>{{$t("detalles_de_contacto")}}
            </h4>
          </v-col>


          <v-row>
            <v-col cols="12" md="6">
              <ValidationProvider v-slot="{ errors }" rules="required|email">
                <v-text-field
                    :label="$t('email_principal')+ '*'"
                    filled
                    v-model="bodega.email_principal"
                    maxlength="250"
                    :error-messages="errors"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="6">
              <ValidationProvider v-slot="{ errors }" :rules="{ required: true, tel: /^\+[0-9 ]+$/ }">
                <v-text-field
                    :label="$t('telefono') + '*'"
                    filled
                    v-model="bodega.telefono"
                    maxlength="20"
                    @focus="msk('telefono','+34')"
                    @blur="unmsk('telefono','+34')"
                    :error-messages="errors"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <ValidationProvider v-slot="{ errors }" rules="email">
                <v-text-field
                    :label="$t('email_visitas')"
                    filled
                    v-model="bodega.email_visitas"
                    maxlength="250"
                    :error-messages="errors"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" md="6">
              <ValidationProvider v-slot="{ errors }">
                <v-text-field
                    :label="$t('web')"
                    filled
                    v-model="bodega.web"
                    maxlength="250"
                    @focus="msk('web','https://')"
                    @blur="unmsk('web','https://')"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="2">

              <v-checkbox v-model="bodega.tienda_online" class="mx-2" :label="$t('tienda_online')"></v-checkbox>
            </v-col>
            <v-col v-if="bodega.tienda_online" cols="12" md="4">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                    :label="$t('indica_URL')+ '*'"
                    filled
                    v-model="bodega.tienda_online_url"
                    maxlength="250"
                    @focus="msk('tienda_online_url','https://')"
                    @blur="unmsk('tienda_online_url','https://')"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="6">
              <ValidationProvider v-slot="{ errors }" rules="email">
                <v-text-field
                    :label="$t('email_para_comunicaciones')"
                    filled
                    v-model="bodega.email_comunicaciones"
                    maxlength="250"
                    :error-messages="errors"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col md="6">
              <ValidationProvider v-slot="{ errors }" rules="email">
                <v-text-field
                    :label="$t('email_para_comunicaciones')+' 2'"
                    filled
                    v-model="bodega.email_comunicaciones_2"
                    maxlength="250"
                    :error-messages="errors"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

           <v-row>

             <v-col md="12">
              <ValidationProvider v-slot="{ errors }" :rules="{ tel: /^\+[0-9 ]+$/ }">

                <v-text-field
                    :label="$t('telefono_o_extension_para_comunicaciones')"
                    filled
                    v-model="bodega.telefono_comunicaciones"
                    maxlength="100"
                    @focus="msk('telefono_comunicaciones','+34')"
                    @blur="unmsk('telefono_comunicaciones','+34')"
                    :error-messages="errors"

                ></v-text-field>
              </ValidationProvider>
            </v-col>

           </v-row>

          <v-col cols="12">
            <h4> {{$t("idioma_preferente_para_las_comunicaciones")}}
            </h4>
          </v-col>

          <v-row>
            <v-col md="12">
              <v-radio-group v-model="bodega.idioma" row>

                <v-radio
                    :label="$t('espanol')"
                    value="es"
                ></v-radio>
                <v-radio
                    :label="$t('catalan')"
                    value="ca"
                ></v-radio>

              </v-radio-group>
            </v-col>
          </v-row>

          <v-col cols="12">
            <h4>{{$t("archivos")}}
            </h4>
          </v-col>

          <v-row>
            <v-col md="12">
              <div class="pb-5" v-if="bodega.logo">

                <div class="mb-3" style="width:150px;padding:10px;border-radius: 200px;border:1px solid #efefef">
                  <img style=";width: 100%; height:auto;;border-radius: 200px;" v-if="logo" :src="$store.state.baseurl+logo">
                </div>

                <v-btn class="" @click="bodega.logo=null" large color="red" dark>{{$t('Cambiar logo')}}</v-btn>

              </div>
              <div v-else>
                <ValidationProvider v-slot="{ errors, validate, valid }" ref="xxx"
                                    rules="required|size:5000|ext:jpg,png">
                  <v-file-input
                      :label="$t('logo_de_la_bodega_fondo_blanco_o_transparente_max_5mb')+'*'"
                      filled
                      p-icon="mdi-camera"
                      :error-messages="errors"
                      @change="handleFileChange"
                      accept="image/png, image/jpeg"
                  ></v-file-input>

                </ValidationProvider>
              </div>
              <div class="pt-4" v-if="bodega.foto">
                <div>
                  <img v-if="foto" :src="$store.state.baseurl+foto">
                </div>

                <v-btn @click="bodega.foto=null" large color="red" dark>{{$t('Cambiar foto')}}</v-btn>
              </div>
              <div v-else>
                <ValidationProvider v-slot="{ errors, validate, valid }" ref="yyy"
                                    rules="required|size:5000|ext:jpg,png|maxdimensions:500,500">
                  <v-file-input
                      :label="$t('foto_horizontal_de_la_bodega_Max_5mb')+'*'"
                      filled
                      p-icon="mdi-camera"
                      :error-messages="errors"
                      @change="handleFileChange2"
                      accept="image/png, image/jpeg"


                  ></v-file-input>
                </ValidationProvider>
              </div>
            </v-col>
          </v-row>

          <v-col cols="12">
            <h4>{{$t("descripcion")}}
            </h4>
          </v-col>

          <ValidationProvider v-slot="{ errors }" rules="required|under_200">
            <v-textarea
                filled
                :label="$t('descripción_de_la_bodega_espanol_max_200_caracteres')+'*'"
                v-model="bodega.desc_es"
                :error-messages="errors"

            ></v-textarea>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" rules="under_200">
            <v-textarea
                filled
                :error-messages="errors"
                :label="$t('Descripcion_de_la_bodega_Catalan_Max_200_caracteres')"
                v-model="bodega.desc_ca"
            ></v-textarea>
          </ValidationProvider>
          <ValidationProvider v-slot="{ errors }" rules="under_200">
            <v-textarea
                filled
                :error-messages="errors"
                :label="$t('Descripción_de_la_bodega_Ingles_Max_200_caracteres')"
                v-model="bodega.desc_en"
            ></v-textarea>
          </ValidationProvider>


          <v-col cols="12">
            <h4>{{$t('redes_sociales')}}
            </h4>
          </v-col>

          <v-row>
            <v-col>
              <ValidationProvider v-slot="{ errors }" :rules="{ url: /https:.*$/ }">
                <v-text-field
                    label="Facebook"
                    filled
                    v-model="bodega.facebook"
                    maxlength="250"
                    :error-messages="errors"
                    placeholder="https://facebook.com/--------"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider v-slot="{ errors }" :rules="{ url: /https:.*$/ }">
                <v-text-field
                    label="Twitter"
                    filled
                    v-model="bodega.twitter"
                    maxlength="250"
                    :error-messages="errors"
                    placeholder="https://twitter.com/--------"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider v-slot="{ errors }" :rules="{ url: /https:.*$/ }">
                <v-text-field
                    label="Instagram"
                    filled
                    v-model="bodega.instagram"
                    maxlength="250"
                    :error-messages="errors"
                    placeholder="https://instagram.com/--------"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider v-slot="{ errors }" :rules="{ url: /https:.*$/ }">
                <v-text-field
                    label="Youtube"
                    filled
                    v-model="bodega.youtube"
                    maxlength="250"
                    :error-messages="errors"
                    placeholder="https://youtube.com/--------"

                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <ValidationProvider v-slot="{ errors }" :rules="{ url: /https:.*$/ }">
                <v-text-field
                    label="LinkedIn "
                    filled
                    v-model="bodega.linkedin"
                    maxlength="250"
                    :error-messages="errors"
                    placeholder="https://linkedin.com/--------"

                ></v-text-field>
              </ValidationProvider>
            </v-col>

          </v-row>
          <v-alert type="info" v-if="showAlert()">
            {{$t("wait_for_upload_to finish")}}
          </v-alert>
          <v-btn @click="submit" large color="primary" dark>{{$t('enviar')}}</v-btn>
        </v-form>
      </ValidationObserver>

    </div>


  </v-container>
</template>

<script>
    import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
    import UploadService from "../services/UploadFilesService";
    import http from "../http-common";
    import axios from "axios"

    setInteractionMode('eager')

    export default {
        name: 'Bodega',

        components: {
            ValidationProvider, ValidationObserver
        },

        data: () => ({
            userNormal:true,
            insubmit: false,
            key: false,
            user: null,
            hascontent: null,
            success: false,
            logo: null,
            foto: null,
            municipios: [
                "Abrera",
                "Aiguamurcia",
                "Ainzón",
                "Albinyana",
                "Alella",
                "Alesanco",
                "Alió",
                "Almendralejo",
                "Aranda de Duero",
                "Artés",
                "Avinyonet del Penedès",
                "Azofra",
                "Banyeres del Penedès",
                "Barberà de la Conca",
                "Begues",
                "Bellvei",
                "Blancafort",
                "Blanes",
                "Bonastre",
                "Briones",
                "Bràfim",
                "Cabra del Camp",
                "Cabrera d’Igualada",
                "Cabrils",
                "Calafell",
                "Canyelles",
                "Capmany",
                "Cariñena",
                "Casalarreina",
                "Castellet i la Gornal",
                "Castellvi de Rosanes",
                "Castellvi de la Marca",
                "Cervelló",
                "Cihuri",
                "Corbera de Llobregat",
                "Cordovín",
                "Cornellá de Llobregat",
                "Creixell",
                "Cubelles",
                "Cunit",
                "Cuzcurrita de Rio Tirón",
                "El Catllar",
                "El Masnou",
                "El Montmell",
                "El Pla de Santa Maria",
                "El Pla del Penedès",
                "El Vendrell",
                "El Vilosell",
                "Els Garidells",
                "Els Hostelets de Pierola",
                "Els Pallaresos",
                "Figuerola del Camp",
                "Font-Rubí",
                "Fonzaleche",
                "Fulleda",
                "Garriguella",
                "Gelida",
                "Grávalos",
                "Guimerà",
                "Haro",
                "Hormilla",
                "Hormilleja",
                "La Bisbal del Penedès",
                "La Granada",
                "La Llacuna",
                "La Nou de Gaià",
                "La Pobla de Claramunt",
                "La Riera de Gaià",
                "La Secuita",
                "Laguardia",
                "Les Cabanyes",
                "Lleida",
                "Llorenç del Penedès",
                "L’Albi",
                "L’Arboç",
                "L’Espluga Calva",
                "L’Espluga de Francolí",
                "Maldà",
                "Martorell",
                "Martorelles",
                "Masarac",
                "Masllorenç",
                "Masquefa",
                "Mediona",
                "Mendavia",
                "Mollet de Perelada",
                "Mongat",
                "Montblanc",
                "Montferri",
                "Moreda de Álava",
                "Nulles",
                "Nájera",
                "Odena",
                "Olesa de Bonesvalls",
                "Olivella",
                "Olérdola",
                "Oyón",
                "Pacs del Penedès",
                "Perafort",
                "Perelada",
                "Piera",
                "Pira",
                "Pontons",
                "Premià de Mar",
                "Puigdalber",
                "Puigpelat",
                "Renau",
                "Requena",
                "Rocafort de Queralt",
                "Roda de Berà",
                "Rodonyà",
                "Rubí",
                "Sajazarra",
                "Salomó",
                "San Asensio",
                "Sant Cugat Sesgarrigues",
                "Sant Esteve Sesrovires",
                "Sant Jaume dels Domenys",
                "Sant Llorenç d’Hortons",
                "Sant Martí Sarroca",
                "Sant Martí de Riucorb",
                "Sant Pere de Ribes",
                "Sant Pere de Riudevitlles",
                "Sant Quintí de Mediona",
                "Sant Sadurní d’Anoia",
                "Sant fost de Campsentelles",
                "Santa Fe del Penedès",
                "Santa Margarida i els Monjos",
                "Santa Maria de Martorelles",
                "Santa Maria de Miralles",
                "Santa Oliva",
                "Sarral",
                "Sitges",
                "Solivella",
                "Subirats",
                "Tarrés",
                "Teià",
                "Tiana",
                "Tirgo",
                "Torrelavit",
                "Torrelles de Foix",
                "Turís",
                "Uruñuela",
                "Vallbona d’Anoia",
                "Vallirana",
                "Vallmoll",
                "Valls",
                "Verdú",
                "Vespella",
                "Viana",
                "Vila-rodona",
                "Vilabella",
                "Vilaberd",
                "Vilafranca del Penedès",
                "Vilanova i la Geltrú",
                "Vilaseca de Solcina",
                "Vilassar de Dalt",
                "Villalba de Rioja",
                "Vilobí del Penedès",
                "Vimbodí",
                "Vinaixa"
            ],
            snackbar: false,
            timeout: 5000,
            progress1: 0,
            progress2: 0,
            bodega: {
                nombre_comercial: "",
                direccion: "",
                municipio: "",
                codigo_postal: "",
                produccion_organica: false,
                produccion_biodinamica: false,
                produccion_integral: false,
                joven: false,
                reserva: false,
                gran_reserva: false,
                paraje: false,
                usa: false,
                japan: false,
                belgum: false,
                uk: false,
                germany: false,
                france: false,
                holand: false,
                sweeden: false,
                enoturismo: false,
                mercados_otros: false,
                mercados_otros_text: "",
                email_principal: "",
                telefono: "",
                email_visitas: "",
                web: "",
                tienda_online: false,
                tienda_online_url: "",
                email_comunicaciones: "",
                email_comunicaciones_2: "",
                telefono_comunicaciones: "",
                idioma: "es",
                logo: "",
                foto: "",
                desc_es: "",
                desc_en: "",
                desc_ca: "",
                facebook: "",
                twitter: "",
                instagram: "",
                linkedin: "",

            },
            items: [
                "aaaaaa", "bbbbb", "cccccc"
            ],
            rules: [v => v.length <= 200 || 'Max 200 characters'],
        }),
        methods: {

            msk(n, str) {
                if (this.bodega[n] == "") {
                    this.bodega[n] = str
                }
            },
            unmsk(n, str) {
                console.log(this.bodega[n])
                if (this.bodega[n] == str) {
                    this.bodega[n] = ""
                }
            },


            submit() {
                this.$refs.observer.validate().then(success => {
                    if (!success) {
                        this.$store.commit("showMessage",{color:"green",content:"hay errores de validación"})
                        const el = document.querySelector(".v-messages.error--text:first-of-type");
                        el.scrollIntoView(true);
                        window.scrollBy(0, -150);
                        return;
                    }
                    this.insubmit = true

                    if (this.mode == "post") {
                        this.bodega.user = this.$store.state.userid
                    }

                    const config = {
                        method: this.mode,
                        url: this.$store.state.endpoints.bodega+this.id,
                        headers: {Authorization: "Bearer " + this.$store.state.jwt},
                        data: this.bodega
                    };
                    console.log("Bodega",this.bodega)
                    axios(config)
                        .then((response) => {
                            this.$store.commit("showMessage",{color:"green",content:this.$i18n.t("Guardado")})
                            this.$store.dispatch('getUser')
                            this.router.push("bodega")
                        })
                        .catch(error => {
                            console.log(error)
                        });
                })
            },
            async handleFileChange(e, progress, file) {
                const {valid} = await this.$refs.xxx.validate(e);
                if (valid) {
                    this.progress1 = 0
                    UploadService.upload(e, (event) => {
                        this.progress1 = Math.round((100 * event.loaded) / event.total);
                    })
                        .then((response) => {
                            this.bodega.logo = response.data.id
                        })
                        .catch(() => {
                            this.progress1 = 0;
                        });
                }
            },
            async handleFileChange2(e, progress, file) {
                const {valid} = await this.$refs.yyy.validate(e);
                if (valid) {
                    this.progress2 = 0
                    UploadService.upload(e, (event) => {
                        this.progress2 = Math.round((100 * event.loaded) / event.total);
                    })
                        .then((response) => {
                            this.bodega.foto = response.data.id
                        })
                        .catch(() => {
                            this.progress2 = 0;
                        });
                }
            },
            disableSubmit() {
                if (this.progress1 + this.progress2 == 100) {
                    return false
                }
                if (this.progress1 + this.progress2 >= 1 && this.progress1 + this.progress2 < 200) {
                    return true
                } else if (this.insubmit === true) {
                    return true
                } else {
                    return false
                }
            },
            showAlert() {
                if (this.progress1 + this.progress2 == 100) {
                    return false
                }

                if (this.progress1 + this.progress2 >= 1 && this.progress1 + this.progress2 < 200) {
                    return true
                } else {
                    return false
                }
            },
            getUrl(url, obj) {
                const config = {
                    headers: {Authorization: "Bearer " + this.$store.state.jwt},
                };
                axios.get(this.$store.state.endpoints.bodega + url, config).then(response => {
                    console.log(response.data)
                    this[obj] = response.data.url
                })
            }
        },
        watch: {
            'bodega.logo': function (newVal, oldVal) {
                if (newVal > 0) {
                    this.getUrl(`${newVal}/getlogo/`, 'logo')
                }
            },
            'bodega.foto': function (newVal, oldVal) {
                if (newVal > 0) {
                    this.getUrl(`${newVal}/getfoto/`, 'foto')
                }
            }
        },
        mounted() {
            const config = {
                headers: {Authorization: "Bearer " + this.$store.state.jwt},
            };
            if(this.$route.params.id){
                this.id = this.$route.params.id + "/"
                this.mode = "put"
                this.title = this.$i18n.t("Editar")

                axios.get(this.$store.state.endpoints.bodega + this.id, config)
                    .then((response) => {

                      this.bodega = response.data


                      let u = this.$store.state.userid
                      if(typeof u == "string"){
                        u = parseInt(u)
                      }
                      let uu = this.$store.state.userid
                      if(typeof uu == "string"){
                        uu = parseInt(uu)
                      }

                      if ([1,4,31,32].includes(u)) {
                        this.userNormal = false
                      }

                      if (![1,4,31,32].includes(u)) {
                        if (uu != u) {
                          this.$router.push('/');
                          //alert(this.bodega.user+" redirects"+( typeof this.$store.state.userid)+" "+this.$store.state.userid)
                        }

                      }

                    })
                    .catch(error => {
                        console.log(error)
                    });
            }
            else{
                this.mode = "post"
                this.id = ""
            }


        }
    };
</script>

<style>
    .m-top {
        margin-top: 30px
    }
</style>
